import { Button, CardActions } from '@mui/material'
import React from 'react'
import { useSelector } from 'react-redux'

import { Form } from '@/app/component/form'
import SubmitButton from '@/app/component/form/submit-button'
import { selectDefaultCountryCode } from '@/app/module/utils/store/selectors'

import { AccountFormValues, accountSchema, getAccountFields } from './specs'

type Props = {
  data: Partial<AccountFormValues>
  email: string
  isLoading: boolean

  onBack: (data: AccountFormValues) => void
  onSubmit: (data: AccountFormValues) => void
}

const AccountForm: React.FC<Props> = ({ data = {}, email, isLoading, onBack, onSubmit }) => {
  const defaultCountryCode = useSelector(selectDefaultCountryCode)

  const defaultValues = React.useMemo(
    () => ({
      email: email || data.email || '',
      phone: data.phone || '',
      password: data.password || '',
    }),
    [data, email],
  )
  const fields = React.useMemo(() => getAccountFields(defaultCountryCode), [defaultCountryCode])

  const handleSubmit = (values: AccountFormValues) => onSubmit(values)
  const handleBack = (values: AccountFormValues) => onBack(values)

  return (
    <Form
      defaultValues={defaultValues}
      fields={fields}
      schema={accountSchema}
      onSubmit={handleSubmit}
      renderActions={(_, { getValues }) => (
        <CardActions sx={{ marginTop: 2, padding: 0 }}>
          <Button variant="outlined" onClick={() => handleBack(getValues())}>
            Back
          </Button>
          {/** Don't check dirty here since it can block the form submission */}
          <SubmitButton isDirty isSubmitting={isLoading}>
            Create Account
          </SubmitButton>
        </CardActions>
      )}
    />
  )
}

export default AccountForm
